import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATES_APPROVED_PERMISSIONS,
  AFFILIATES_LIST_QUERY_KEY,
  CHANGE_AFFILIATE_STATUS_API_URL,
  CHANGE_AFFILIATE_STATUS_MUTATION_KEY,
} from '../constants';

export default function useChangeAffiliateStatusMutation(): IContextMutationResult<void, Error, number> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [CHANGE_AFFILIATE_STATUS_MUTATION_KEY],
    mutationFn: (affiliateId) => fetchPost<void>(
      CHANGE_AFFILIATE_STATUS_API_URL,
      affiliateId,
      {
        permission: AFFILIATES_APPROVED_PERMISSIONS.CHANGE_BAN_STATUS,
        urlParams: {
          affiliateId,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATES_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
